import { Typography } from '@atlas-metrics/design-system';
import React, { PropsWithChildren } from 'react';

import Badge from './Badge';
import FilledCard from './FilledCard';

type WidgetsCardProps = PropsWithChildren<{
  title: string;
  network?: string;
  className?: string;
}>;

const WidgetsCard: React.FC<WidgetsCardProps> = ({
  title,
  network,
  children,
  className,
}) => {
  return (
    <FilledCard className={className}>
      <div className='m-4 flex flex-row flex-wrap gap-2'>
        <Typography variant='body-l' bold className='text-left text-black'>
          {title}
        </Typography>
        {network && (
          <Badge variant='info' size='xs'>
            {network}
          </Badge>
        )}
      </div>
      {children}
    </FilledCard>
  );
};

export default WidgetsCard;
